/**
 * @architecture-header 1
 * @layer module
 * @domain activities
 * @responsibility Render the main-header `#tgoto` and `#tadd` controls for the activity library.
 * @state-owner activities UI store holds the upload draft
 * @allowed-imports React; activities store; workspace store; shared components and hooks
 * @forbidden in-product role switching; direct API client
 * @public-api workspace main column
 * @side-effects opens the upload dialog and navigates to a class
 * @tests workspace Playwright flows in frontend/apps/web/e2e/workspace.spec.ts
 */

import { useOverlay } from '../../../shared/components/OverlayHost';
import { useTranslator } from '../../../shared/model/use-workspace';
import { useWorkspaceUiStore } from '../../../shared/model/workspace-store';
import { useSelectedActivityClass } from '../model/use-activity-filter';
import { useActivityUiStore } from '../store/activity-ui-store';
import { UploadDialog } from './UploadDialog';

export function UploadButton() {
  const t = useTranslator();
  const { openModal } = useOverlay();
  const navigate = useWorkspaceUiStore((state) => state.navigate);
  const startUpload = useActivityUiStore((state) => state.startUpload);
  const classIndex = useSelectedActivityClass();

  return (
    <>
      {classIndex != null ? (
        <button
          className="bt"
          id="tgoto"
          style={{ marginRight: 8 }}
          type="button"
          onClick={() => navigate('room', `c${classIndex}`)}
        >
          {t('前往班級')}
        </button>
      ) : null}
      <button
        className="bt pri addbt"
        id="tadd"
        title={`${t('新增')} · C`}
        type="button"
        onClick={() => {
          startUpload(classIndex);
          openModal(<UploadDialog />);
        }}
      >
        {t('新增')}
        <svg aria-hidden="true" viewBox="0 0 24 24">
          <path d="M12 5v14M5 12h14" />
        </svg>
      </button>
    </>
  );
}
